// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
// import { ServiceWorkerModule } from '@angular/service-worker';
import { HttpClientModule } from '@angular/common/http';
import { WebAuth } from 'auth0-js';
import { AppComponent } from './app.component';
import {
  CoreModule,
  FLAGS_TOKEN,
  LOG_LEVEL_TOKEN,
  LogLevel,
  ENVIRONMENT_KEY,
  RouterStateUrlSerializer,
  reducers,
  effects,
  // SENTRY_CONFIG_KEY,
  API_KEY,
  WEB_AUTH_TOKEN,
  STORAGE_TOKEN
} from '@app/core';
import { SharedModule } from '@app/shared';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';

// @ts-ignore
console.log(environment.AUTH0_DOMAIN);
console.log(environment.AUTH0_CLIENT_ID);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    StoreModule.forRoot(reducers as any),
    // ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    EffectsModule.forRoot(effects),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router'
    })
    // StoreDevtoolsModule.instrument({
    //   maxAge: 25,
    //   logOnly: environment.production // Restrict extension to log-only mode
    // })
  ],
  providers: [
    { provide: FLAGS_TOKEN, useValue: FLAGS },
    { provide: LOG_LEVEL_TOKEN, useValue: LogLevel.Verbose },
    { provide: STORAGE_TOKEN, useValue: localStorage },
    {
      provide: WEB_AUTH_TOKEN,
      useValue: new WebAuth({
        domain: environment.AUTH0_DOMAIN,
        clientID: environment.AUTH0_CLIENT_ID,
        responseType: 'token id_token'
      })
    },
    // {
    //   provide: SENTRY_CONFIG_KEY,
    //   useValue: {
    //     dsn: SENTRY_DSN,
    //     enabled: environment.production
    //   }
    // },
    {
      provide: ENVIRONMENT_KEY,
      useValue: {
        stage: STAGE,
        commit: COMMIT
      }
    },
    {
      provide: API_KEY,
      useValue: environment.API_URL
    },
    { provide: RouterStateSerializer, useClass: RouterStateUrlSerializer }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts